import React from "react";
import Table from "../../components/subcomponents/table";
import TableControl from "../../components/subcomponents/table_control";
import Button from "../../components/subcomponents/controls/button";
import InputField from "../../components/subcomponents/controls/inputfield";
import CheckField from "../../components/subcomponents/controls/checkfield";
import { connect } from "react-redux";
import subscriptions from "../../api/subscriptions";
import notification from "../../components/subcomponents/notification";
import SubformDetails from "../../components/subcomponents/subform_details";
import FormHeader from "../../components/subcomponents/formheader";
import SelectField from "../../components/subcomponents/controls/selectfield";
import isPermitted from "../../permissions/permissions";

class subscriptionsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allow_to_edit: false,
            edit_rec: false,
            new_rec: false,
        };
    }
    componentWillMount() {
        subscriptions.list();
        subscriptions.options();
        this.props.handleSelect();
    }
    selectItem(id) {
        if (this.state.new_rec || this.state.allow_to_edit) {
            notification.error("New/edit rec mode, please cancel before select");
            return null;
        }
        if (id) {
            this.setState({ edit_rec: true });
            this.setState({ allow_to_edit: false });
            this.props.handleSelect(id);
            subscriptions.details();
        } else {
            this.cancel();
        }
    }
    cancel() {
        this.setState({ new_rec: false });
        this.setState({ edit_rec: false });
        this.setState({ allow_to_edit: false });
        this.props.handleSelect();
        subscriptions.list();
    }
    newRec() {
        this.props.handleSelect();
        this.setState({ new_rec: true });
    }
    saveRec() {
        let self = this;
        if (this.state.edit_rec) {
            subscriptions.update((error) => {
                if (!error) {
                    self.cancel();
                }
            });
        } else {
            subscriptions.add(function (error) {
                if (!error) {
                    self.cancel();
                }
            });
        }
    }
    deleteRec() {
        let self = this;
        subscriptions.del(function (error) {
            if (!error) {
                subscriptions.list();
                self.cancel();
            }
        });
    }
    allowEdit(params) {
        this.setState({ allow_to_edit: params.value });
    }
    showDetails() {
        let details_title = this.state.edit_rec
            ? "Subscription details"
            : "Enter new subscription";
        let save_btn_label = this.state.edit_rec
            ? "Update subscription"
            : "Add new subscription";
        let confirm_toggle_status = !this.state.new_rec ? "enabled" : "hidden";

        let save_btn =
            this.props.subscription_details.company_id &&
                this.props.subscription_details.date_till
                ? "enabled"
                : "disabled";
        if (this.state.edit_rec && !this.state.allow_to_edit) save_btn = "hidden";

        let del_btn =
            this.state.edit_rec && this.state.allow_to_edit ? "enabled" : "hidden";

        let inputs_enabled =
            this.state.allow_to_edit || this.state.new_rec ? "enabled" : "disabled";

        //TODO: refactor
        return (
            <SubformDetails
                is_hidden={!this.state.new_rec && !this.state.edit_rec}
                title={details_title}
                className="details width_50"
            >
                <CheckField
                    status={confirm_toggle_status}
                    name="allow_to_edit"
                    label="Enable edit"
                    onChange={this.allowEdit.bind(this)}
                    value={this.state.allow_to_edit}
                />
                <SelectField
                    status={inputs_enabled}
                    name="company_id"
                    label="Company"
                    options={this.props.subscription_options["company_id"]}
                    onChange={this.props.fieldChange}
                    value={this.props.subscription_details.company_id}
                    error={this.props.subscription_validation["company_id"]}
                />
                <InputField
                    name="date_till"
                    status={inputs_enabled}
                    label="Valid till"
                    onChange={this.props.fieldChange}
                    value={this.props.subscription_details.date_till}
                    input_control={{
                        numericOnly: true,
                        delimiters: ["-"],
                        blocks: [4, 2, 2],
                    }}
                    placeholder="YYYY-MM-DD"
                    error={this.props.subscription_validation["date_till"]}
                />
                <div className="toolbar">
                    <Button
                        name="add"
                        label={save_btn_label}
                        onClick={this.saveRec.bind(this)}
                        status={save_btn}
                    />
                    <Button
                        name="delete"
                        label="Delete subscription"
                        onClick={this.deleteRec.bind(this)}
                        status={del_btn}
                    />
                    <Button
                        name="cancel"
                        label="Cancel"
                        onClick={this.cancel.bind(this)}
                    />
                </div>
            </SubformDetails>
        );
    }
    render() {
        let new_btn = this.state.edit_rec ? "hidden" : "enabled";
        const filter = (isPermitted("Admin"))
            ? { options: this.props.subscription_options["company_id"], value: this.props.subscription_filter["company_id"] }
            : null
        return (
            <div className="form_wrap admin_list">
                <FormHeader title="SUBSCRIPTIONS LIST" />
                <SubformDetails className="master width_50">
                    <TableControl
                        search={this.props.search_string}
                        filter={filter}
                        handleSearch={this.props.handleSearch}
                        handleFilter={this.props.handleFilter}
                    />
                    <Table
                        name="subscriptions_list"
                        table_key={"subscription_id"}
                        handleSelect={this.selectItem.bind(this)}
                        selected={this.props.subscription_selected}
                        headers={{
                            subscription_id: { label: "ID", width: "10%" },
                            company_name: { label: "Name", width: "60%" },
                            date_till: { label: "Valid", width: "30%" },
                        }}
                        data={this.props.subscriptions_list}
                    />
                    <Button
                        name="new"
                        label="New subscription"
                        onClick={this.newRec.bind(this)}
                        status={new_btn}
                    />
                </SubformDetails>
                {this.showDetails()}
            </div>
        );
    }
}

/**
 * [Converts plain obj to arr for state]
 * @param obj
 */
function stateArr(obj = {}) {
    let state_arr = [];
    Object.keys(obj).forEach((field) => {
        state_arr.push(obj[field]);
    });
    return state_arr;
}

function mapStateToProps(state) {
    let subscriptions = state.subscriptionsR.subscriptions;
    return {
        search_string: subscriptions.search_string,
        subscription_filter: subscriptions.filter,
        subscription_options: subscriptions.options,
        subscriptions_list: subscriptions.list,
        subscription_selected: subscriptions.selected,
        subscription_validation: subscriptions.validation,
        subscription_details: subscriptions.details,
        subscription_state: stateArr(subscriptions.detail),

        companies_validation: subscriptions.validation,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        handleSearch(result) {
            dispatch({
                type: "SUBSCRIPTIONS_DESELECTED",
            });
            dispatch({
                type: "SUBSCRIPTIONS_UPDATE_SEARCH_STRING",
                value: result.value,
            });
            subscriptions.list();
        },
        handleFilter(result) {
            dispatch({
                type: "SUBSCRIPTIONS_DESELECTED",
            });
            dispatch({
                type: "SUBSCRIPTIONS_UPDATE_FILTER_STRING",
                value: result.value ? { [result.name]: result.value } : {},
            });
            subscriptions.list();
        },
        handleSelect(id) {
            if (id) {
                dispatch({
                    type: "SUBSCRIPTIONS_SELECTED",
                    value: id,
                });
            } else {
                dispatch({
                    type: "SUBSCRIPTIONS_DESELECTED",
                });
            }
        },
        cancelSelect() {
            dispatch({
                type: "SUBSCRIPTIONS_CANCEL_SELECT",
            });
        },
        fieldChange(result) {
            dispatch({
                type: "SUBSCRIPTIONS_UPDATE_FORM",
                field: result.name,
                value: result.value,
            });
        },
    };
}

export default subscriptionsList = connect(
    mapStateToProps,
    mapDispatchToProps
)(subscriptionsList);
